(function ($) {
  jQuery.get("https://pro.ip-api.com/json/?key=MQXSLbxUAhwAwzB", function(response) {
    if(response.countryCode == 'US') {
      var messageContainer = $('.fixed-message-section');
      var fixedMessageCookie = Cookies.get('fixed-message');
      if (fixedMessageCookie !== 'dismiss') {
        messageContainer.removeClass('is-hidden');
      }
      // Attach event to hide fixed message if button is clicked
      $('.js-close-fixed-message').on('click', () => {
        messageContainer.hide();
        Cookies.set('fixed-message', 'dismiss', { expires: 10 });
      });
    }
  }, "jsonp"); 
})(jQuery);